<template>
	<div class="main-quests lok-scrollbar">
		<ToastMessage
			class="pin-message"
			:show-message="!!pinStatus"
			:message="pinStatus ?? ''"
			uppercase
		/>
		<QuestBox
			:quest="activeMainQuest"
			v-if="activeMainQuest"
			@action="emit('action')"
			@pin-action="pinAction($event)"
			@claim-rewards="claimDailyQuest(activeMainQuest.id)"
		/>
		<div v-else class="no-quest-texts">
			<div>{{ translate("ui.story_quests_done") }}</div>
			<div>{{ translate("ui.more_quests_in_updates") }}</div>
		</div>
		<AppTextButton
			class="chronicle-button"
			:text="translate('button.chronicle')"
			:type="StatusTypes.DEFAULT"
			:shadow="true"
			@click="handleChronicleOpen"
		/>
	</div>
</template>

<script lang="ts" setup>
import AppTextButton from "@/components/AppTextButton.vue";
import QuestBox from "@/components/Quests/QuestBox.vue";
import ToastMessage from "@/components/ToastMessage.vue";
import { QuestTypes } from "@/game/entities/config/quests/quest_types.js";
import SoundService from "@/game/SoundService";
import useQuestStore from "@/store/useQuestStore";
import type { QuestActive } from "@/types/quest";
import { type QuestPinStatus } from "@/types/quest";
import { StatusTypes } from "@/types/ui";
import { translate } from "@/utils/translate";
import { storeToRefs } from "pinia";
import { computed, markRaw, ref } from "vue";
const soundService = markRaw(SoundService.getInstance());

const { getActiveQuests } = storeToRefs(useQuestStore());

const emit = defineEmits(["popup", "action", "claimRewards"]);

const pinStatus = ref<string | null>(null);

const activeMainQuest = computed(
	(): QuestActive | null =>
		getActiveQuests.value.find(
			(q: QuestActive): boolean => q.type === QuestTypes.MAIN,
		) || null,
);

const pinAction = (status: { pinStatus: QuestPinStatus }): void => {
	pinStatus.value = status.pinStatus;
	setTimeout((): void => {
		pinStatus.value = null;
	}, 1_000);
};

const handleChronicleOpen = (): void => {
	soundService.playGenerickClick();
	emit("popup", "chronicle");
};
const claimDailyQuest = (id: number): void => {
	emit("claimRewards", id);
};
</script>

<style lang="scss" scoped>
.main-quests {
	width: 100%;
	@include flex-col-start;
	position: relative;
	gap: 1rem;
	padding: 1rem;

	.no-quest-texts {
		@include flex-col-center;
	}

	.pin-message {
		position: absolute;
		top: 0;
		right: 0.6rem;
	}
}
</style>
